// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader___q7ec","no-header":"style_no-header__1nxPk"};